var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialFacebook20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Commbank-Footer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "md---768---977---New-footer",
    transform: "translate(-504.000000, -384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facebook-icon",
    transform: "translate(504.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,22 C17.0749647,22 22,17.0756115 22,11 C22,4.92568203 17.0749647,0 11,0 C4.92503528,0 0,4.92568203 0,11 C0,17.0756115 4.92503528,22 11,22",
    id: "Fill-1",
    fill: "#547BBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,9.01375333 L9.34816504,9.01375333 L9.34816504,7.94619698 C9.34816504,7.47582254 9.36003372,6.74933452 9.70235138,6.30019876 C10.0621597,5.82420231 10.5568962,5.5 11.4070683,5.5 C12.7925803,5.5 13.3760195,5.69801952 13.3760195,5.69801952 L13.1017906,7.32527773 C13.1017906,7.32527773 12.6439095,7.19284827 12.2166371,7.19284827 C11.7899894,7.19284827 11.4070683,7.34589175 11.4070683,7.77316415 L11.4070683,9.01375333 L13.1586353,9.01375333 L13.0368252,10.6029068 L11.4070683,10.6029068 L11.4070683,16.1249654 L9.34816504,16.1249654 L9.34816504,10.6029068 L8.25,10.6029068 L8.25,9.01375333 Z",
    id: "Fill-4",
    fill: "#FEFEFE"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook20);
export default __webpack_public_path__ + "static/media/socialFacebook20.224dede020b2eca1bcb3b459657f8dcf.svg";
export { ForwardRef as ReactComponent };